<template>
  <div class="wrapper">
    <!-- navbar -->
    <!-- <div @click="navChange" ref="navlist" class="navlist">
      <div
        :data-index="nav.id"
        :ref="'nav_item' + nav.id"
        class="nav_item"
        :class="{ active: nav.id == currentNav }"
        v-for="nav in navList"
        :key="nav.id"
      >
        {{ nav.name }}
      </div>
    </div> -->

    <div class="nav-page" v-if="currentNav==0" >
      <div class="container">
        <book class="item" v-for="(item, index) in datalist" :obj="item" :key="index"></book>
      </div>
      <el-empty v-if="total == 0" description="暂无数据"></el-empty>
      <div class="pagination l_flex_row_center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total,  prev, pager, next, jumper"
          :total="total"
          :hide-on-single-page="true"
        >
        </el-pagination>

        
      </div>
      <div class="tip-box">
          <div class="tip-text">
            友情提示：更多书籍将不定时更新...
          </div>
      </div>

    </div>
    <div v-if="currentNav==1" class="nav-page pageview">
      <img src="../../../assets/img/js_.jpg" alt="">
    </div>
  </div>
</template>

<script>
import book from "@/components/book.vue";
export default {
  components: {
    book,
  },
  props: {},
  data() {
    return {
      currentPage: 1,
      datalist: [],
      total: 1,
      navList: [
        {
          id: 0,
          name: "活动书籍",
        },
        {
          id: 1,
          name: "百部经典书籍介绍",
        },
      ],
      currentNav: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 分页切换
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getActivitydBooks(this.currentPage);
    },
    //获取活动书籍
    async getActivitydBooks(page = 1) {
      try {
        let res = await this.$api.getActivityBookList({
          params: {
            page: page,
          },
        });
        // console.log('get booklist',res);
        this.datalist = res.data.list;
        this.total = res.data.num;
      } catch (error) {
        console.log("error");
      }
    },
    //
    initNav() {
      this.$nextTick(() => {
        const navlist_el = this.$refs.navlist;
        const scroll_width = this.$refs["nav_item0"][0].clientWidth;
        this.setNavVar(0, scroll_width);
      });
    },
    // 导航切换
    navChange(e) {
      const { index } = e.target.dataset;
      if (index) {
        this.currentNav = index;
        let movex = 0;
        for (let i = 0; i < index; i++) {
          movex += this.$refs["nav_item" + i][0].clientWidth;
        }
        movex = movex + 30 * index;
        this.setNavVar(movex, this.$refs["nav_item" + index][0].clientWidth);
        console.log("index", index, movex);
      }
    },
    setNavVar(movex, width) {
      this.$refs.navlist.style.setProperty("--scrollx", movex);
      this.$refs.navlist.style.setProperty("--scrollw", width);
    },
  },
  created() {
    // console.log('activitybooks');
    // this.initNav();
    this.getActivitydBooks(this.currentPage);
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  min-width: 1200px;
  // width: 1200px;
  // padding-top: 67px;
  // margin: 0 auto;
  display: flex;
  justify-content: center;
  // align-items: center;
  background: url("~@//assets/img/3000.jpg") no-repeat center;
  background-size: 100% 100%;
  margin-top: -191px;
  padding-top: 250px;
  padding-bottom: 240px;
  .container {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
  }
  .item {
    // width: calc((1200px - (3 * 26px)) / 4);
    // margin-right: 26px;
    // margin-bottom: 40px;
    width: 276px;
    margin-right: 32px;
    margin-bottom: 21px;

    &:nth-child(4n) {
      margin-right: 0px;
    }
  }
  .pagination {
    height: 100px;
  }

  ::v-deep .el-pagination__total, ::v-deep .el-pagination__jump{
      color: #fff;
    }

  //
  .navlist {
    display: flex;
    align-items: center;
    height: 60px;
    line-height: 60px;
    position: relative;
    margin: 20px 0;
    --scrollw: 0;
    --scrollx: 0;
    &::after {
      display: block;
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 5px;
      background-color: #ccc;
      z-index: 10;
    }
    &::before {
      display: block;
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: calc(1px * var(--scrollw));
      height: 5px;
      background-color: #855a3d;
      z-index: 100;
      transform: translate3d(calc(1px * var(--scrollx)), 0, 0);
      transition: all 0.3s ease-in-out;
      border-radius: 5px;
    }
    .nav_item {
      margin-right: 30px;
      font-weight: bold;
      font-size: 20px;
      color: #999;
      cursor: pointer;
      &.active {
        color: #855a3d;
      }
      &:hover {
        color: #855a3d;
      }
    }
  }
  .pageview{
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
  }

  .tip-box{
    display: flex;
    align-items: center;
    justify-content: center;
    .tip-text{
      height: 40px;
      line-height: 40px;
      border: 1px solid #815a4e;
      color: #815a4e;
      padding: 0 40px;
      margin: 20px;

    }
  }
}
</style>
